// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f_a3C","pointer":"styles_pointer__FcbJG"};